module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/bp-4-512.923c85bdd5d53aab.jpg"+" 512w",
        images: [{path: "https://static.sniffspot.com/packs/img/bp-4-512.923c85bdd5d53aab.jpg",width: 512,height: 341}],
        src: "https://static.sniffspot.com/packs/img/bp-4-512.923c85bdd5d53aab.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/bp-4-512.923c85bdd5d53aab.jpg"},
        
        width: 512,
        height: 341
      }